<template>
  <div>
    <v-navigation-drawer
      :value="isOpenLogDetails"
      :permanent="isOpenLogDetails"
      width="40vw"
      max-width="100vw"
      right
      fixed
      temporary
      style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
    >
      <v-card min-height="100vh" color="grey lighten-3">
        <BaseToolbar
          :button-save="false"
          @close="close"
          title="Detalles del cargo"
          type-title="icon"
        />
        <v-card-text style="overflow-y: auto; height: calc(100vh - 64px)">
          <v-container class="pa-5">
            <v-expansion-panels class="no-shadow" v-model="panel" multiple>
              <v-expansion-panel expand v-model="panel">
                <v-expansion-panel-header>
                  <b class="body-2 font-weight-bold">
                    {{ $t("afrus_engine.log.details.information") }}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0">
                  <v-divider />
                  <v-card-text>
                    <v-container>
                      <v-row dense>
                        <v-col cols="12">
                          <VueJsonPretty
                            :data="
                              log.gateway
                                ? {
                                    gateway: log.gateway,
                                    leadId: log.lead_id,
                                    chargeId: log.charge_id,
                                    subscriptionId: log.subscription_id,
                                    success: log.charge_success,
                                    cantBeScheduled: log.cant_be_scheduled,
                                    maxAttemptsPerMonthReached: log.max_attempts_per_month_reached,
                                    chargeRescheduled: log.charge_rescheduled,
                                    date: log.created_at,
                                  }
                                : {
                                    message: 'No data available',
                                  }
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel expand v-model="panel">
                <v-expansion-panel-header>
                  <b class="body-2 font-weight-bold">
                    {{ $t("afrus_engine.log.details.data") }}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0">
                  <v-divider />
                  <v-card-text>
                    <v-container>
                      <v-row dense>
                        <v-col cols="12">
                          <VueJsonPretty
                            :data="
                              log.charge_data
                                ? log.charge_data
                                : {
                                    message: 'No data available',
                                  }
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import VueJsonPretty from "vue-json-pretty";
import BaseToolbar from "@/components/BaseToolbar";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "LogDetails",
  components: { BaseToolbar, VueJsonPretty },
  data() {
    return {
      panel: [0],
    };
  },
  computed: {
    ...mapGetters({
      log: "afrusEngine/log",
      isOpenLogDetails: "afrusEngine/isOpenLogDetails",
    }),
  },
  methods: {
    ...mapMutations({
      setIsOpenLogDetails: "afrusEngine/setIsOpenLogDetails",
    }),
    close() {
      this.setIsOpenLogDetails(false);
    },
  },
};
</script>

<style></style>
